import React from 'react';
import { useSymbolTileConfigSlice } from 'widgets/symbolTile/store/instances/config/configslice';
import { SymbolTileConfigState } from 'widgets/symbolTile/store/instances/config/SymbolTileConfigState';
import './SymbolTileSettings.scss';
import WidgetSettingsShowDataForEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsShowDataForEditor';
import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';

import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export const SymbolTileSettingsText = `Price Capsule Settings`;
export const SymbolTileModalClassName = 'SymbolTileSettingsModal';

export interface SymbolTileSettingsProps {
    config?: SymbolTileConfigState;
    onChange?: (nextDelta: Partial<SymbolTileConfigState>) => void;
}

export default function SymbolTileSettings(props: SymbolTileSettingsProps) {
    const { onChange, config: propsConfig } = props;

    const { config: configSliceConfig, dispatchConfigChanged } =
        useSymbolTileConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );

    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="SymbolTileSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsShowDataForEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>
            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
